import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "checkout" };
const _hoisted_2 = {
    class: "checkout__wrap",
    method: "post"
};
const _hoisted_3 = { class: "checkout__main" };
const _hoisted_4 = { class: "checkout-form" };
const _hoisted_5 = { class: "checkout-form__main" };
const _hoisted_6 = { class: "checkout__extra" };
import { computed, ref, useTemplateRef, watch } from 'vue';
import BonusAccountPayment from "./components/BonusAccountPayment.vue";
import OrderSum from "../../components/order/OrderSum.vue";
import PaymentBlock from "./components/PaymentBlock.vue";
import DeliveryDateBlock from "./components/delivery/DeliveryDateBlock.vue";
import ContactsBlock from "./components/ContactsBlock.vue";
import { useOrderStore } from "./store";
import { storeToRefs } from "pinia";
import { StatusClassNames } from "../../types/StatusClassNames";
import DeliveryBlock from "./components/delivery/DeliveryBlock.vue";
import { usePaymentApi } from "../ready/api";
import EventBus from "../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderApp',
    props: {
        allowSkipCall: Boolean,
        cdek: Object,
        cashPaymentAllowRegions: Boolean,
        cashPaymentBanned: Boolean,
        cashPaymentDiscount: Number,
        userLoggedIn: Boolean,
        formData: { type: Object, default: {} },
        errors: { type: Object, default: {} },
        token: String,
        address: Object,
    },
    setup(__props) {
        var _a;
        const props = __props;
        const store = useOrderStore();
        const { sumToPay, delivery, deliveryPrice, deliveryService, totalSum, orderSum, usedBonuses, bonusAmount, currentPaymentSystem, paymentSystem, paymentSystems, } = storeToRefs(store);
        const address = ref(props.address);
        const date = ref(props.formData.delivery_date);
        const time = ref((_a = props.formData.delivery_time) !== null && _a !== void 0 ? _a : '');
        const dateFormatted = ref(props.formData.delivery_date_formatted);
        const cashPaymentDiscount = ref(props.cashPaymentDiscount);
        const courierDeliveryAvailable = ref(false);
        const contactsBlock = useTemplateRef('contactsBlock');
        const isCourier = computed(() => { var _a; return ['courier', 'sameday'].includes((_a = deliveryService.value) === null || _a === void 0 ? void 0 : _a.type); });
        const readyToOrder = computed(() => {
            var _a;
            if (!delivery.value) {
                return false;
            }
            if (isCourier.value && (!time.value || ((_a = deliveryService.value) === null || _a === void 0 ? void 0 : _a.type) === 'courier' && !date.value)) {
                return false;
            }
            return sumToPay.value ? paymentSystem.value : true;
        });
        const cashPaymentsConfig = computed(() => {
            var _a;
            const defaults = {
                availableForLocation: courierDeliveryAvailable.value,
                loggedIn: props.userLoggedIn,
                personalBan: props.cashPaymentBanned,
                discount: cashPaymentDiscount.value,
            };
            if (!address.value) {
                return Object.assign({ available: false, banned: false }, defaults);
            }
            const isRegions = !(['Москва', 'Санкт-Петербург'].includes(address.value.cityName) || ['Москва', 'Московская', 'Санкт-Петербург'].includes(address.value.region));
            return Object.assign(Object.assign({}, defaults), { available: delivery.value && isCourier.value, availableForLocation: ((_a = deliveryService.value) === null || _a === void 0 ? void 0 : _a.cash_disabled) === true ? false : courierDeliveryAvailable.value, banned: props.cashPaymentBanned || (isRegions && !props.cashPaymentAllowRegions) });
        });
        watch(address, () => {
            if (address.value && address.value.delivery.name === 'courier') {
                courierDeliveryAvailable.value = true;
            }
        });
        watch(deliveryService, deliveryService => store.setDeliveryService(deliveryService));
        watch(paymentSystem, recalculateOrder);
        watch(usedBonuses, recalculateOrder);
        function recalculateOrder() {
            var _a, _b;
            cashPaymentDiscount.value = usedBonuses.value ? 0 : props.cashPaymentDiscount;
            usePaymentApi().recalculateOrder(paymentSystem.value, address.value, (_a = usedBonuses.value) !== null && _a !== void 0 ? _a : 0, ((_b = deliveryService.value) === null || _b === void 0 ? void 0 : _b.type) === 'sameday')
                .then(response => {
                if (response.ok) {
                    orderSum.value = response.order;
                }
            });
        }
        EventBus.on('order:delivery-list-updated', services => courierDeliveryAvailable.value = services.courier.available);
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(ContactsBlock, {
                                    errors: __props.errors,
                                    formData: __props.formData,
                                    token: __props.token,
                                    allowSkipCall: __props.allowSkipCall,
                                    ref_key: "contactsBlock",
                                    ref: contactsBlock
                                }, null, 8 /* PROPS */, ["errors", "formData", "token", "allowSkipCall"]),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                _createVNode(DeliveryBlock, {
                                    "same-day-delivery-available": "",
                                    formData: __props.formData,
                                    orderSum: _unref(orderSum),
                                    "user-logged-in": __props.userLoggedIn,
                                    address: address.value,
                                    "onUpdate:address": _cache[0] || (_cache[0] = ($event) => ((address).value = $event)),
                                    delivery: _unref(deliveryService),
                                    "onUpdate:delivery": _cache[1] || (_cache[1] = ($event) => (_isRef(deliveryService) ? (deliveryService).value = $event : null))
                                }, null, 8 /* PROPS */, ["formData", "orderSum", "user-logged-in", "address", "delivery"]),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                (address.value && isCourier.value && ((_a = _unref(deliveryService)) === null || _a === void 0 ? void 0 : _a.available))
                                    ? (_openBlock(), _createBlock(DeliveryDateBlock, {
                                        key: 0,
                                        errors: __props.errors,
                                        address: address.value,
                                        "same-day": ((_b = _unref(deliveryService)) === null || _b === void 0 ? void 0 : _b.type) === 'sameday',
                                        calendar: (_c = _unref(deliveryService)) === null || _c === void 0 ? void 0 : _c.calendar,
                                        time: time.value,
                                        "onUpdate:time": _cache[2] || (_cache[2] = ($event) => ((time).value = $event)),
                                        modelValue: date.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((date).value = $event)),
                                        "date-formatted": dateFormatted.value,
                                        "onUpdate:dateFormatted": _cache[4] || (_cache[4] = ($event) => ((dateFormatted).value = $event))
                                    }, null, 8 /* PROPS */, ["errors", "address", "same-day", "calendar", "time", "modelValue", "date-formatted"]))
                                    : _createCommentVNode("v-if", true),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                (address.value && _unref(delivery) && ((_d = _unref(deliveryService)) === null || _d === void 0 ? void 0 : _d.available))
                                    ? (_openBlock(), _createBlock(PaymentBlock, {
                                        key: 1,
                                        disabled: !_unref(delivery),
                                        systems: _unref(paymentSystems),
                                        error: __props.errors.payment,
                                        sum: _unref(sumToPay),
                                        "cash-config": cashPaymentsConfig.value,
                                        modelValue: _unref(paymentSystem),
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(paymentSystem) ? (paymentSystem).value = $event : null))
                                    }, null, 8 /* PROPS */, ["disabled", "systems", "error", "sum", "cash-config", "modelValue"]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(BonusAccountPayment, {
                            "account-amount": _unref(bonusAmount),
                            "total-sum": _unref(totalSum),
                            modelValue: _unref(usedBonuses),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (_isRef(usedBonuses) ? (usedBonuses).value = $event : null))
                        }, null, 8 /* PROPS */, ["account-amount", "total-sum", "modelValue"]),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createVNode(OrderSum, {
                            deliveryPrice: _unref(deliveryPrice),
                            "total-sum": _unref(sumToPay),
                            orderSum: _unref(orderSum),
                            usedBonuses: _unref(usedBonuses),
                            "payment-type": (_e = _unref(currentPaymentSystem)) === null || _e === void 0 ? void 0 : _e.type,
                            "show-bonuses": !!_unref(bonusAmount)
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: _normalizeClass(["btn btn--1 btn--l btn--black wide", { [_unref(StatusClassNames).disabled]: !readyToOrder.value }])
                                }, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("span", { class: "btn__label" }, "Оформить заказ", -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["deliveryPrice", "total-sum", "orderSum", "usedBonuses", "payment-type", "show-bonuses"])
                    ])
                ])
            ]));
        };
    }
});
